import React, { useEffect, useContext } from 'react';
import Chart from 'react-apexcharts';
import { patchAxisTitles } from '../../JS/Common';
import useConfig from '../../Hooks/useConfig';

export default function AveragePart(props) {
    const { organization, hover_type } = useConfig();
    var vData = props.schooldata;
    var series = [{
        data: vData.map(item => ({
            x: item.school,
            y: item.avrg,
            total_tickets: item.total_tickets,
            ticket_attachment_count: item.ticket_attachment_count
        }))
    }];
    var labels = vData.map(item => item.school);
    var chartHeight = Math.max(300, vData.length * 5);

    var options = {
        chart: {
            type: 'bar',
        },
        plotOptions: {
            bar: {
                borderRadius: 0,
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val;
            },
        },
        xaxis: {
            categories: labels,
            labels: {
                rotate: -45,
                formatter: function (value) {
                    if (!value) return value;
                    if (value.length > 15) {
                        return value.substring(0, 15) + '...';
                    }
                    return value;
                },
            },
        },
        colors: ['var(--primary-color)'],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
                    var totalTickets = w.config.series[seriesIndex].data[dataPointIndex].total_tickets;
                    var ticketAttachmentCount = w.config.series[seriesIndex].data[dataPointIndex].ticket_attachment_count;
                    var avrgparts = val;
                    return "Total Tickets : " + totalTickets + "<br/>Attached Parts : " + ticketAttachmentCount + "<br/>Average Parts : " + avrgparts;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    }
                }
            }

        },
        chart: {
            toolbar: {
                show: false,
                offsetX: 0,
                offsetY: 0,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: []
                },
                export: {
                    csv: {
                        filename: "tickets_distribution_by_school",
                        columnDelimiter: ',',
                        headerCategory: `${organization},Amount,Total Tickets`,
                        headerValue: '',
                        headerSeries: '',
                        dateFormatter(timestamp) {
                            return new Date(timestamp).toDateString()
                        },
                        dropShadow: false
                    },
                    svg: {
                        filename: "tickets_distribution_by_school",
                    },
                    png: {
                        filename: "tickets_distribution_by_school",
                    }
                },
                autoSelected: 'zoom'
            },
            events: {
                mounted(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(labels, chartContext.el);
                    });
                },
                updated(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(labels, chartContext.el);
                    });
                },
                resized(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(labels, chartContext.el);
                    });
                }
            }
        }
    };

    return (
        <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%", borderRadius: "10px", backgroundColor: "white" }}>
            <div className="w-100">
                <h4>Average parts per ticket per {organization}</h4>
                <div style={{ overflowX: "scroll" }}>
                    <div className="" style={{
                        width: series[0]?.data?.length > 10 ? "2000px" : "100%",
                    }}>
                        <Chart options={options} series={series} type="bar" height={chartHeight} id="average-parts-ticket-chart" />
                    </div>
                </div>
            </div>
        </div >
    );
}